<template>
  <footer class="footer">
    <Container>
      
      <FadeIn class="footer-logo">
        <LogoFooter />
        <div class="footer-logo__headline">
          Tools to speak up safely
        </div>
      </FadeIn>
      
      <FadeIn class="footer-nav">

        <div class="footer-nav__col">
          <div class="h5">Platform</div>
          <ul>
            <li>
              <NuxtLink :to="$localePath('/features')">
                Features
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/security')">
                Security
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/trust')">
                Trust
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/pricing')">
                Pricing
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div class="footer-nav__col lgp:order-4">
          <div class="h5">Resources</div>
          <ul>
            <li>
              <NuxtLink :to="$localePath('/blog')">
                Insights
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/webinars')">
                Webinars
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div class="footer-nav__col lgp:order-5">
          <div class="h5">Company</div>
          <ul>
            <li>
              <NuxtLink :to="$localePath('/about')">
                About Elker
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/book-demo')">
                Book a demo
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/contact')">
                Contact us
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div class="footer-nav__col md:order-6 lgp:order-6">
          <div class="h5">Social</div>
          <ul>
            <li>
              <NuxtLink to="https://www.linkedin.com/company/elkerofficial/?originalSubdomain=au" target="_blank">
                LinkedIn
              </NuxtLink>
            </li>
          </ul>
          <div class="h5 !mt-8">Alternatives</div>
          <ul>
            <li>
              <NuxtLink :to="$localePath('/alternative/eqs-integrity-line-alternative')">
                EQS Integrity Line alternative
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div class="footer-nav__col md:order-4 lgp:order-2">
          <div class="h5">Solutions</div>
          <ul>
            <li>
              <NuxtLink :to="$localePath('/use-cases/businesses')">
                Businesses
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/use-cases/universities')">
                Universities
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/use-cases/schools')">
                Schools
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/use-cases/government')">
                Government
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/use-cases/peak-bodies')">
                Peak bodies
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/use-cases/aged-care-disability-services')">
                Aged care & disability services
              </NuxtLink>
            </li>
          </ul>
        </div>

        <div class="footer-nav__col md:order-5 lgp:order-3">
          <div class="h5">Use cases</div>
          <ul>
            <li>
              <NuxtLink :to="$localePath('/solutions/speak-up-platform')">
                Speak-up platform
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/solutions/case-management-software')">
                Case management software
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/solutions/psychosocial-hazard-management')">
                Psychosocial hazard management
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/solutions/whistleblowing-platform')">
                Whistleblowing platform
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/solutions/whistleblowing-hotline')">
                Whistleblowing hotline
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/solutions/workplace-investigation-software')">
                Workplace investigation software
              </NuxtLink>
            </li>
            <li>
              <NuxtLink :to="$localePath('/solutions/anonymous-suggestion-box')">
                Anonymous suggestion box
              </NuxtLink>
            </li>
          </ul>
        </div>


      </FadeIn>

      <FadeIn class="mt-12 border-t border-[#3e3e3e] pt-8 sm:mt-12 lg:mt-16 flex flex-row gap-x-8 justify-center">
        <div class="footer-copy">
          <NuxtLink 
          :to="$localePath('/policies/privacy')"
          class="text-center mb-4 md:mb-0 block md:inline">
            Privacy policy
          </NuxtLink>
          <span class="hidden md:inline text-white">·</span>
          <NuxtLink 
          :to="$localePath('/policies/cookies')"
          class="text-center mb-4 md:mb-0 block md:inline">
            Cookie policy
          </NuxtLink>
          <span class="hidden md:inline text-white">·</span>
          <NuxtLink
          :to="$localePath('/policies/terms')" 
          class="text-center mb-4 md:mb-0 block md:inline">
            Terms of use
          </NuxtLink>
          <span class="hidden md:inline text-white">·</span>
          <NuxtLink 
          :to="$localePath('/policies/whistleblowing')"
          class="text-center mb-4 md:mb-0 block md:inline">
            Whistleblowing policy
          </NuxtLink>
          <span class="hidden md:inline text-white">·</span>
          <NuxtLink
          :to="$localePath('/policies/anti-modern-slavery')" 
          class="text-center block md:inline">
            Anti-modern slavery policy
          </NuxtLink>
        </div> 
      </FadeIn>

      <FadeIn class="mt-8 border-t border-[#3e3e3e] pt-8 md:flex justify-center md:justify-between">

        <div class="footer-nav__col display-block text-center md:text-left">
          <div class="h5"><Icon name="ph:globe-light" class="text-white text-xl" /> <span style="position: relative; top: -3px;">Country select</span></div>
          <ul>
            <li><NuxtLink :to="$switchLocalePath('au')">Australia / Global {{ locale === 'au' ? '✓' : '' }}</NuxtLink></li>
            <li><NuxtLink :to="$switchLocalePath('nz')">New Zealand {{ locale === 'nz' ? '✓' : '' }}</NuxtLink></li>
          </ul>
        </div>

        <div class="mt-8 sm:mt-12 flex md:mt-0 justify-center md:justify-end md:gap-x-4">
          <NuxtLink
          :to="$localePath('/trust?client=elker')"
          class="transition-shadow ease-in-out duration-300 !h-[64px] flex !w-[270px] items-center bg-white border-2 border-[#c0c7fa] rounded-[5px] transition-colors overflow-hidden"
          >
            <div class="flex items-center justify-center w-[66px] h-[66px] border-r-2 border-[#c0c7fa] items-center">
              <img loading="lazy" src="https://cdn.elker.com/elker_badge_1_3349c30058.png" alt="Elker Safe Space Employer badge" style="width: 60px; height: 60px;" />
            </div>
            <div class="flex flex-col justify-center px-3 w-[206px] text-left">
              <span class="text-[14px] font-bold text-gray-900 mb-1">Employee-safe workplace</span>
              <span class="text-[11px] text-gray-700 leading-tight">Elker is committed to creating a safe and respectful workplace.</span>
            </div>
          </NuxtLink>
        </div>

      </FadeIn>

    </Container>
  </footer>

</template>

<script setup>
const { locale } = useI18n()
useSchemaOrg([
{
  "@context": "http://schema.org",
  "@type": "SoftwareApplication",
  "image": "https://cdn.elker.com/elker_logo_651cfb3fa6.png",
  "name": "Elker",
  "applicationCategory": "Human Resources",
  "operatingSystem": "MULTI",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "reviewCount": "204"
  },
  "offers": {
    "@type": "Offer",
    "price": "Custom",
    "priceCurrency": "AUD"
  }
}
])
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';

.footer {
  padding-top: $space*4;
  padding-bottom: $space*6;
  // background: #fefefe;
  background: #262626;
  a {
    font-size: 14px;
    transition: $transition-all;
    color: #d2d2d2;
    text-decoration: none;
    &:hover {
      color: #fff;
    }
  }
  @media (max-width: calc($breakpoint-sm - 1px)) {
    font-size: 14px;
    padding-top: $space*3;
  }
}

.footer-logo {
  text-align: center;
  svg {
    width: 130px;
    height: 40px;
    display: inline-block;
  }
  @media (max-width: calc($breakpoint-sm - 1px)) {
    svg {
      width: 100px;
      height: 30px;
    }
  }
}

.footer-logo__headline {
  margin-top: $space;
  font-size: 1.5rem;
  font-weight: 600;
  color: #fff;
  @media (max-width: calc($breakpoint-sm - 1px)) {
    font-size: 1.2rem;
  }
}

.footer-copy, .footer-address {
  font-size: 13px;
  span {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.footer-nav {
  margin-top: $space*3;
  margin-bottom: $space*3;
  justify-content: space-between;
  @media (min-width: $breakpoint-sm) {
    margin-top: $space*4;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 2rem;
  }
  @media (min-width: 1200px) {
    margin-top: $space*4;
    display: flex;
    // grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 2rem;
  }
  @media (max-width: calc($breakpoint-sm - 1px)) {
    display: grid;
    row-gap: $space;
    column-gap: $space;
    grid-template-columns: repeat(2, minmax(0,1fr));
  }
}

.footer-nav__col {
  grid-column: span 1 / span 1;
  @media (min-width: 1200px) {
    grid-column: 'auto';
  }
  .h5 {
    color: #fff;
    font-weight: 600;
    margin-bottom: $space*.5;
    font-size: 1.1rem;
    margin-bottom: 10px;
    margin-top: 15px;
    @media (min-width: $breakpoint-sm) {
      margin-top: 15px;
    }
    @media (min-width: $breakpoint-md) {
      margin-top: 0;
    }
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    line-height: 1.4;
    margin-bottom: 9px;
    @media (min-width: $breakpoint-sm) {
      line-height: 1.3;
      margin-bottom: 10px;
    }
  }
}
</style>